export default {
  apply_submit: 'Wyślij zgłoszenie',
  apply_submitting: 'Wysyłanie...',
  apply_cv_label: 'CV',
  apply_coverLetter_label: 'List motywacyjny',
  apply_email_label: 'Email',
  apply_name_label: 'Imię i nazwisko',
  apply_sex_label: 'Płeć',
  apply_ssn_label: 'Numer ubezpieczenia społecznego',
  apply_phone_label: 'Telefon',
  apply_successModal_title: 'Zgłoszenie zarejestrowane',
  apply_successModal_text:
    'Potwierdzenie zostało wysłane na Twój adres e-mail. Jeśli nie otrzymasz potwierdzenia w ciągu kilku minut, sprawdź folder Spam.',
  apply_successModal_backToJobs: 'Powrót do listy ofert',
  apply_error_required: 'Pole wymagane',
  apply_error_email: 'Wprowadzono nieprawidłowy adres e-mail',
  apply_error_ssn: 'Wprowadzono nieprawidłowy numer ubezpieczenia społecznego',

  backToJobs: 'Powrót do listy ofert',
  backToDetail: 'Powrót do opisu stanowiska',
  openings_singular: '{0} Aktualny wakat',
  openings_plural: '{0} Aktualne wakaty',
  no_openings: 'Nie mamy teraz ofert pracy',
  apply_button: 'Aplikuj teraz',
  deadline_display: 'Termin',
  deadline_none: 'Brak terminu',
  vacancies_singular: 'aktualne ogłoszenie',
  vacancies_plural: 'aktualne ogłoszenia',
  filter_search_placeholder: 'Szukaj...',
  openings_showing_singular: 'Wyświetlono {0} / {1} ofertę',
  openings_showing_plural: 'Wyświetlono {0} / {1} ofert',
  filter_no_results_main: 'Brak ofert pasujących do wyszukiwania lub filtrów',
  filter_no_results_sub: 'Zmień wyszukiwanie lub zresetuj filtry',
  clear_all: 'Wyczyść wszystko',
  select_placeholder: 'Wybierz...',
  upload_file: 'Prześlij plik',
  accept_terms_body_text:
    'Zaznacz tutaj, aby zaznaczyć, że przeczytałeś i zgadzasz się z warunkami',
  fifty_privacy_policy: ' Polityka jakości 50 skills',
  privacy_policy_and: ' i',
  company_privacy_policy: '{0} Polityka jakości',
  terms_agreement_required: 'Wymagana jest zgoda na warunki',
  apply_form_has_errors: 'Popraw zaznaczone pola przed wysłaniem',
  job_list_no_openings_main: 'W chwili obecnej nie mamy ofert pracy',
  job_list_no_openings_sub: 'Sprawdź w późniejszym czasie!',
  job_list_no_language_data: 'Ta oferta pracy nie ma tłumaczenia na język polski',
  job_list_no_language_data_sub:
    'Aby przeczytać ofertę w innym języku przełącz go w prawym górnym rogu.',
  jobStatus_full_time: 'Pełny etat',
  jobStatus_part_time: 'Część etatu',
  jobStatus_per_diem: 'Na godziny',
  jobStatus_not_specified: 'Nie określono',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Wybierz język',
  job_does_not_exist_header: 'Strona nie istnieje',
  job_does_not_exist_sub_header: 'Adres został błędnie wpisany lub oferta pracy została usunięta',
  job_does_not_exist_link: 'Powrót na stronę główną',
  fiftyFooter_poweredBy: 'Powered by',
  jobStatus_title: 'Status ogłoszenia',
  cookie_consent_main_text: 'Korzystając ze strony wyrażasz zgodę na naszą',
  cookie_consent_privacy_cta_text: ' politykę plików cookie.',
  cookie_consent_privacy_button_text: 'Odrzuć',
  department_title: 'Dział',
  department_unspecified: 'Nie określono',
};
